import { render, staticRenderFns } from "./RamaisList.vue?vue&type=template&id=31b28119"
import script from "./RamaisList.vue?vue&type=script&lang=ts"
export * from "./RamaisList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports